<div class="report">
    <div class="report-option">
        <div class="report-option-provider">
            <p-radioButton name="optionname" [inputId]="'optionid'" [value]="'1'" [(ngModel)]="optionValue" (click)="selectOption('1')"/>
        </div>
        <div class="report-option-provider-lbl">
            Search by Provider
        </div>      
        <div class="report-option-grp">
            <p-radioButton name="optionname" [inputId]="'optionid'" [value]="'2'" [(ngModel)]="optionValue" (click)="selectOption('2')"/>
        </div>
        <div class="report-option-grp-lbl">
            Search by Group
        </div>  
    </div>
    <div class="report-component">
        <div *ngIf="optionValue == '1'">
            <app-reports-provider-search #providersearchcomponent (onProviderSearch)="onProviderSearch($event)"></app-reports-provider-search>            
        </div>        
        <div *ngIf="optionValue == '2'">
            <app-reports-group-search #groupsearchcomponent (onSearch)="onGroupSearch($event)"></app-reports-group-search>
        </div>                
    </div>
</div>


